var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsBoolean, IsDateString, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import { Role } from '../../roles/index.js';
import { UserProfileDto } from '../../user/index.js';
export class CallPatientLiteDto {
    id;
    createdAt;
    updatedAt;
    patientId;
    callId;
    patient;
    hasConnected;
    isAllowedEntry;
}
__decorate([
    IsString(),
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], CallPatientLiteDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", Date)
], CallPatientLiteDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", Date)
], CallPatientLiteDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", String)
], CallPatientLiteDto.prototype, "patientId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], CallPatientLiteDto.prototype, "callId", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Type(() => UserProfileDto),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", Object)
], CallPatientLiteDto.prototype, "patient", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST] }),
    __metadata("design:type", Boolean)
], CallPatientLiteDto.prototype, "hasConnected", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], CallPatientLiteDto.prototype, "isAllowedEntry", void 0);
//# sourceMappingURL=call-patient.lite.dto.js.map